import React from "react";
import CalendarDatePicker from "ui/components/comp-507";

const DepartmentFilers = ({ filters, setFilters }) => {
  const handleDateRangeChange = (dateRange) => {
    setFilters({
      ...filters,
      startDate: dateRange?.from || null,
      endDate: dateRange?.to || null,
    });
  };

  const dateRange = {
    from: filters.startDate,
    to: filters.endDate,
  };

  return (
    <div>
      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
    </div>
  );
};

export default DepartmentFilers;
